/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {PersonDtoModel} from './person-dto.model';

export class ContactDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  personDTO: PersonDtoModel | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  email: string | undefined = undefined;
  visibilityType: string | undefined = undefined;
  contactMethod: string | undefined = undefined;
  receivesRequests: boolean | undefined = undefined;
  deleted: string | undefined = undefined;
  businessProfileUuid: string | undefined = undefined;
  forLegalEntityUuid: string | undefined = undefined;
}
